import classNames from '@utils/classnames';

export interface IDataFieldProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

/** Read-only label / value pair — label always above the value. */
export const DataField: React.FC<IDataFieldProps> = (props) => {
  const { title, children, className } = props;

  return (
    <div className={classNames('min-w-0', className)}>
      <div className="label-text mb-0.5 w-full">{title}</div>
      <div className="text-sm text-fg">{children}</div>
    </div>
  );
};
